/**
 * Segmenta un texto en trozos según si matchean la query (case-insensitive).
 * Devuelve array de `{ text, match }` para renderizar con `<mark>` en template.
 *
 * No usa regex con la query cruda del usuario — escapa caracteres especiales
 * para evitar inyección de regex y fallos en queries con paréntesis, `+`, etc.
 * Devuelve el texto completo como un único segmento sin-match cuando la query
 * está vacía o no aparece en el texto.
 */
export interface HighlightSegment {
  text: string;
  match: boolean;
}

export function highlightMatch(text: string, query: string): HighlightSegment[] {
  if (!text) return [];
  const trimmed = query.trim();
  if (trimmed.length === 0) return [{ text, match: false }];

  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(escaped, 'ig');
  const segments: HighlightSegment[] = [];
  let lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (m.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, m.index), match: false });
    }
    segments.push({ text: m[0], match: true });
    lastIndex = m.index + m[0].length;
    if (m[0].length === 0) re.lastIndex++;
  }
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), match: false });
  }
  return segments.length > 0 ? segments : [{ text, match: false }];
}
